import React from 'react';

import { Skeleton } from '../Skeleton';

/**
 * Скелетон блока-ссылки на Телеграм-канал
 */
export const PostTelegramLinkSkeleton = () => <Skeleton height={130} borderRadius={'8px'} />;
